import { NextPageContext } from 'next';
import { tryGetUserFromHeaders } from 'lib/api';

const checkAuthFromHeaders = (context: NextPageContext) => {
  if (context?.req?.headers) {
    const isUserAuth = tryGetUserFromHeaders(context.req.headers);

    return !(!isUserAuth && process.env.NODE_ENV === 'production');
  }
};

export default checkAuthFromHeaders;
